export default __webpack_public_path__ + "3d8bb208f00d9b2430a95229292160b8.png";